import { render } from "./ScoreRow.vue?vue&type=template&id=9fa14eb2&scoped=true"
import script from "./ScoreRow.vue?vue&type=script&lang=js"
export * from "./ScoreRow.vue?vue&type=script&lang=js"

import "./ScoreRow.vue?vue&type=style&index=0&id=9fa14eb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fa14eb2"]])

export default __exports__